<template>
  <div class="__PreferencesDialogFilterServiceList">
    <div class="__PreferencesDialogFilterServiceList-Content">
      <CRow gutter="md">
        <CCol col="12" xs="12" sm="6">
          <!-- Search Filter -->
          <CSearchBox class="mb-xs" v-model="filter" :placeholder="$t('Search by service name')" />

          <div class="__PreferencesDialogFilterServiceList-List">
            <q-list dense>
              <div class="pa-md" v-if="currentOptions.length === 0">
                {{ $t('No data.') }}
              </div>

              <div class="pa-md" v-else-if="currentOptions.length === 0 && filter !== ''">
                {{ $t('No results') }}
              </div>

              <q-item tag="label" v-for="(val, i) in currentOptions" :key="i" v-else>
                <q-item-section side>
                  <q-checkbox
                    v-model="currentValue"
                    :val="val.id"
                    dense
                    :disable="isDisabled(val.id)"
                  />
                </q-item-section>

                <q-item-section>
                  <q-item-label>
                    {{ val.name }}
                  </q-item-label>
                </q-item-section>
              </q-item>
            </q-list>

            <!-- Loading -->
            <CLoading v-model="loading" />
          </div>
        </CCol>

        <CCol col="12" xs="12" sm="6">
          <div class="__PreferencesDialogFilterServiceList-Selected">
            <div v-for="val of currentSelectedItems" :key="val.id">
              <CChip :label="val.name" removable @remove="onRemove(val.id)" />
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { filterObjFn } from '@/lib/filterFn';
import { awsServices } from '@/mocks/data/chartReportsService.mock';
import CRow from '@/components/uikit/CRow';
import CCol from '@/components/uikit/CCol';
import CSearchBox from '@/components/uikit/CSearchBox';
import CLoading from '@/components/uikit/CLoading';
import CChip from '@/components/uikit/CChip';

export default Vue.extend({
  name: 'PreferencesDialogFilterSeriesList',
  components: { CRow, CCol, CSearchBox, CLoading, CChip },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    category: {
      type: String,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      filter: '',
      loading: false,
    };
  },
  watch: {
    max(count) {
      const values = this.currentValue.filter((val, index) => {
        return index < count;
      });

      this.$emit('input', values);
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value ? this.value : [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },

    currentSelectedItems() {
      return this.currentValue.map(i => {
        const target = this.currentOptions.find(o => {
          return o.name === i;
        });

        return {
          name: target ? target.name : i,
          id: i,
        };
      });
    },

    currentOptions() {
      let options = this.services;

      // Search Filter
      options = filterObjFn(options, this.filter, ['name']);

      return options;
    },

    services() {
      return awsServices.map(i => {
        return {
          name: i,
          id: i,
        };
      });
    },
  },
  methods: {
    isDisabled(id) {
      if (this.currentValue.length < this.max) return false;

      return !this.currentValue.includes(id);
    },

    onRemove(id) {
      this.currentValue = this.currentValue.filter(i => i !== id);
    },
  },
});
</script>

<style lang="scss" scoped>
.q-list::v-deep {
  label {
    display: flex;
  }
}

.__PreferencesDialogFilterServiceList {
  border: 1px solid $border-color;
  border-radius: $border-radius;
  padding: $space-md;

  &-List {
    height: 280px;
    overflow-y: scroll;
  }

  &-Selected {
    padding-top: 48px;
  }
}
</style>
